module.exports = __webpack_public_path__ + "img/ai.7e980c43.png";